export default class extends Controller {
  static targets = ['byDayLabel', 'byWeekLabel', 'startDateField'];

  connect() {
    this.updateRepeatOptions();
  }

  updateRepeatOptions() {
    App.Helpers.ajaxRequest({
      url:            this.url,
      method:         'GET',
      data:           { date: this.date },
      successHandler: res => {
        this.byDayLabelTarget.innerHTML  = res.by_day_label;
        this.byWeekLabelTarget.innerHTML = res.by_week_label;
      }
    });
  }

  //
  // GETTERS AND SETTERS
  //

  get url() {
    return this.data.get('url').replace(/DATE/g, this.date);
  }

  get date() {
    return this.startDateFieldTarget.value;
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/events/campaign-brief-event-repeat-month-fields-controller.js